import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, BoxIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
interface ServiceCardProps {
  title: string;
  description: string;
  icon: BoxIcon;
  delay?: number;
  path?: string;
}
export function ServiceCard({
  title,
  description,
  icon: Icon,
  delay = 0,
  path = '/services'
}: ServiceCardProps) {
  return <motion.div initial={{
    opacity: 0,
    scale: 0.95
  }} whileInView={{
    opacity: 1,
    scale: 1
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.4,
    delay
  }} className="bg-white border border-gray-100 p-8 shadow-sm hover:shadow-xl transition-all duration-300 group relative flex flex-col h-full" data-id="element-151">
      {/* Left Amber Border on Hover */}
      <div className="absolute top-0 left-0 w-1 h-0 bg-brand-amber group-hover:h-full transition-all duration-300 ease-out" data-id="element-152"></div>

      <div className="mb-6" data-id="element-153">
        <Icon className="w-10 h-10 text-brand-navy group-hover:text-brand-amber transition-colors" strokeWidth={1.5} data-id="element-154" />
      </div>

      <h3 className="text-xl font-heading font-bold text-brand-navy mb-3" data-id="element-155">
        {title}
      </h3>

      <p className="text-brand-slate mb-8 line-clamp-2 leading-relaxed flex-grow" data-id="element-156">
        {description}
      </p>

      <Link to={path} className="inline-flex items-center text-sm font-bold text-brand-navy group-hover:text-brand-amber transition-colors mt-auto w-fit" data-id="element-157">
        View Details
        <ArrowRight className="ml-2 w-4 h-4 transform group-hover:translate-x-1 transition-transform" data-id="element-158" />
      </Link>
    </motion.div>;
}